export default __webpack_public_path__ + "static/media/ARUSHI M. MEHTA.0a8e2ac8.jpg";